import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import {
  EmergencyStatusReportUpdated,
  PublisherEmergencyStatus,
  updatePublisherEmergencyStatus,
} from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useUpdatePublisherEmergencyStatus = (
  options: UseMutationOptions<
    EmergencyStatusReportUpdated,
    unknown,
    {
      publisherEmergencyReportId: number;
      newStatus: PublisherEmergencyStatus;
      statusMessage?: string;
    },
    unknown
  > = {}
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (args: {
      publisherEmergencyReportId: number;
      newStatus: PublisherEmergencyStatus;
      statusMessage?: string;
    }) =>
      extractData(
        updatePublisherEmergencyStatus({
          body: {
            publisherEmergencyReportId: args.publisherEmergencyReportId,
            comment: args.statusMessage,
            newStatus: args.newStatus,
          },
        })
      ),
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({
        queryKey: ['emergencyMode', 'publisher-emergency-reports'],
      });
      options.onSuccess?.(...args);
    },
  });
};
